<template>
    <div style="width:100%;height:100%">
        <buttonlist
                ref="SetBtn"
                @help="help"
        ></buttonlist>
        <el-card class="box-card">
            <el-row style="display: flex;background: white">
                <el-button type="primary" size="mini" @click="showitems">{{$t('getapi[4412]')}}</el-button>
                <el-button type="primary" size="mini" @click="remove">{{$t('getapi[437]')}}</el-button>
                <el-col :span="5" style="text-align: left">
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :action="uploadurl"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList"
                            :limit="1"
                            style="margin-left: 8px"
                    >
                        <el-button slot="trigger" size="mini" type="primary">{{$t('getapi[436]')}}</el-button>
                    </el-upload>
                    
                </el-col>
                <el-col :span="18" style="text-align: right">
                    <span style="padding:0 20px;">{{$t('getapi[506]')}}</span>
                    <el-select filterable v-model="editPlan" :placeholder="$t('getapi[6085]')" size="mini">
                        <el-option v-for="item in editPlanList" :key="item.value" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select></el-col>
                <el-col :span="2" style="text-align: right">
                    <el-button type="primary" size="mini" @click="update">{{$t('getapi[507]')}}</el-button>
                    <!-- <el-button type="primary" size="mini">关闭</el-button> -->
                </el-col>
            </el-row>
        </el-card>
        <el-card class="box-card">
            <!-- <div slot="header" class="clearfix">
                <span>质量相关设置</span>
            </div> -->
            <el-table
                    :data="dataSet"
                    v-loading="loading"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="tableHeight"
                    @cell-dblclick="editInfo"
                    tab-click="selectInfo(0)"
                    @selection-change="handleSelectionChange"
                    :row-class-name="tableRowClassName"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
                    ref="singleTable"
            >
                <el-table-column type="selection"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Exclusively_id" label="ID" v-if="false"></el-table-column>
                <!-- <el-table-column show-overflow-tooltip prop="relation_partmaster_id" label="ID" v-if="false"></el-table-column> -->
                -->
                <el-table-column show-overflow-tooltip prop="DataStatus" :label="$t('getapi[504]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[113]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_status" :label="$t('getapi[114]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                <el-table-column :class-name="editPlan == 'KEEP_LONGEST_PERIOD'?'check':''"
                                 prop="KEEP_LONGEST_PERIOD" :label="$t('getapi[185]')">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.KEEP_LONGEST_PERIOD"
                                  v-if="editPlan == 'KEEP_LONGEST_PERIOD'"></el-input>
                        <span v-if="editPlan != 'KEEP_LONGEST_PERIOD'">{{scope.row.KEEP_LONGEST_PERIOD}}</span>
                    </template>
                </el-table-column>
                <el-table-column :class-name="editPlan == 'CHECK_STD'?'check':''" prop="CHECK_STD"
                                 :label="$t('getapi[186]')">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.CHECK_STD"
                                  v-if="editPlan == 'CHECK_STD'"></el-input>
                        <span v-if="editPlan != 'CHECK_STD'">{{scope.row.CHECK_STD}}</span>
                    </template>
                </el-table-column>
                <el-table-column :class-name="editPlan == 'quality_std'?'check':''"
                                 prop="quality_std" :label="$t('getapi[187]')">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.quality_std"
                                  v-if="editPlan == 'quality_std'"></el-input>
                        <span v-if="editPlan != 'quality_std'">{{scope.row.quality_std}}</span>
                    </template>
                </el-table-column>
                <el-table-column :class-name="editPlan == 'Material_Standard'?'check':''"
                                 prop="Material_Standard" :label="$t('getapi[189]')">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.Material_Standard"
                                  v-if="editPlan == 'Material_Standard'"></el-input>
                        <span v-if="editPlan != 'Material_Standard'">{{scope.row.Material_Standard}}</span>
                    </template>
                </el-table-column>
                <el-table-column :class-name="editPlan == 'cargoPosition_code'?'check':''"
                                 prop="cargoPosition_code" :label="$t('getapi[188]')">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.cargoPosition_code"
                                  v-if="editPlan == 'cargoPosition_code'"></el-input>
                        <span v-if="editPlan != 'cargoPosition_code'">{{scope.row.cargoPosition_code}}</span>
                    </template>
                </el-table-column>
                <el-table-column :class-name="editPlan == 'keep_period_flag'?'check':''"
                                 prop="keep_period_flag" :label="$t('getapi[190]')">
                    <template scope="scope">
                        <el-select v-if="editPlan == 'keep_period_flag'" v-model="scope.row.keep_period_flag">
                            <el-option :label="$t('getapi[561]')" :value="1" :key="1"></el-option>
                            <el-option :label="$t('getapi[866]')" :value="0" :key="0"></el-option>
                        </el-select>
                        <!-- <el-input class-name="check" size="small" v-model="scope.row.keep_period_flag" v-if="editPlan == 'keep_period_flag'"></el-input>-->
                        <span v-if="editPlan != 'keep_period_flag'">{{scope.row.keep_period_flag}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <!--<pickpartQ :isVisible="itevisible" @getitembom="getitembom" ref="input"></pickpartQ>-->
        <selector :isVisible="itevisible" :isBatch=true :selectType="0" :isSplitPage=true
                  :postUrl="'/Eng/Parts/QualityGetPart'" @callback="getitembom" ref="input"></selector>
    </div>
</template>
<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';

    export default {
        name: 'qualitysetting',
        data() {
            return {
                itevisible: false,
                dataSet: [],
                dataChecked: [], // 选中的ID集合
                loading: false, // 主表加载状态
                tableHeight: window.innerHeight - 178, // 主表高度
                uploadurl: '',
                fileList: [],
                editPlan: '0',
                editPlanList: [{
                    value: '0',
                    label: this.$t('getapi[852]')//'未选择'
                }, {
                    value: 'KEEP_LONGEST_PERIOD',
                    label: this.$t('getapi[185]')//'保存期'
                }, {
                    value: 'CHECK_STD',
                    label: this.$t('getapi[186]')//'检验标准'
                }, {
                    value: 'quality_std',
                    label: this.$t('getapi[187]')//'质量标准'
                }, {
                    value: 'Material_Standard',
                    label: this.$t('getapi[189]')//'材质标准'
                }, {
                    value: 'cargoPosition_code',
                    label: this.$t('getapi[188]')//'默认货位'
                }, {
                    value: 'keep_period_flag',
                    label: this.$t('getapi[190]')//'启用保质期'
                }],
                scrollTop:0,
            };
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/Eng/Parts/QualityImportUpFile?token=' + token;
        },
        mounted: function () {
            let that = this;
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6012]"),this.$t("getapi[18]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                // //只读权
                that.$refs.SetBtn.SetButtonEnable('');
            },
            // 新物料打开
            showitems() {
                this.itevisible = true;
                this.$refs.input.clearInput(this.itevisible);
            },
            getitembom(data) {
                let that = this
                if(data.length > 0){
                    let arr = []
                    for (let i = 0; i < data.length; i++) {
                        arr.push(data[i].Exclusively_id);
                    }
                    let str = ""
                    for (let i = 0; i < arr.length; i++) {
                        str = str + arr[i] + ","
                    }
                    let ids = str.substr(0, str.length - 1)
                    let parm = {
                        PageIndex: 0,
                        PageSize: 0,
                        Param: {
                            Id: 0,
                            Code: ids,
                            Name: "",
                            Where: ""
                        },
                        id: "",
                        name: ""
                    };
                    that.$http.urlpost('/Eng/Parts/GetPartQuality', parm, function (res) {
                        if (res.Success == 1) {
                            let data = res.DataContent
                            data = data.filter(item => {
                                return that.dataSet.every(item2 => {
                                    return item.Exclusively_id != item2.Exclusively_id;
                                });
                            });
                            for (let i = 0; i < data.length; i++) {
                                that.dataSet = [...that.dataSet, {
                                    part_code: data[i].part_code,
                                    part_version: data[i].part_version,
                                    part_status: data[i].part_status,
                                    part_name: data[i].part_name,
                                    KEEP_LONGEST_PERIOD: data[i].KEEP_LONGEST_PERIOD,
                                    CHECK_STD: data[i].CHECK_STD,
                                    QUALITY_STD: data[i].quality_std,
                                    material_standard: data[i].Material_Standard,
                                    cargoPosition_code: data[i].cargoPosition_code,
                                    keep_period_flag: data[i].keep_period_flag,
                                    relation_partmaster_id: data[i].relation_partmaster_id,
                                    DataStatus: data[i].DataStatus,
                                    Exclusively_id: data[i].Exclusively_id
                                }]
                            }
                            that.dataSet = res.DataContent
                        }
                    });
                }
            },
            handleSelectionChange(val) {
                let that = this;
                for (let i = 0; i < val.length; i++) {
                    that.dataChecked.push(val[i].Exclusively_id);
                }
            },
            remove() {
                let that = this
                let arr = that.dataSet.filter(item => {
                    return that.dataChecked.every(item2 => {
                        return item.Exclusively_id != item2
                    })
                })
                that.dataSet = arr;
                that.fileList = [];
            },
            handleChange(file, fileList) {
                let that = this;
                /*if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        that.dataSet = file.response.DataContent;
                    }
                }*/
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                let response = res.Success;

                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    let data = res.DataContent
                    data = data.filter(item => {
                        return that.dataSet.every(item2 => {
                            return item.Exclusively_id != item2.Exclusively_id;
                        });
                    });
                    for (let i = 0; i < data.length; i++) {
                        that.dataSet = [...that.dataSet, {
                            part_code: data[i].part_code,
                            part_version: data[i].part_version,
                            part_status: data[i].part_status,
                            part_name: data[i].part_name,
                            KEEP_LONGEST_PERIOD: data[i].KEEP_LONGEST_PERIOD,
                            CHECK_STD: data[i].CHECK_STD,
                            QUALITY_STD: data[i].quality_std,
                            material_standard: data[i].Material_Standard,
                            cargoPosition_code: data[i].cargoPosition_code,
                            keep_period_flag: data[i].keep_period_flag,
                            relation_partmaster_id: data[i].relation_partmaster_id,
                            DataStatus: data[i].DataStatus,
                            Exclusively_id: data[i].Exclusively_id
                        }]
                    }
                    that.dataSet = res.DataContent
                }
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(this.$t('getapi[8585]')+':' + err);
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            update() {
                let that = this;
                if (that.editPlan == '0') {
                    that.$message.warning(that.$t('getapi[8625]'));//'请选择更新字段'
                    return
                }
                let parm = {
                    PageIndex: 0,
                    PageSize: 0,
                    Param: that.dataSet,
                    id: "",
                    name: that.editPlan
                };
                that.$http.urlpost('/Eng/Parts/QualityUpdate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    .c-search-table {
        width: 100%;
        height: calc(~'100% - 10px'); /*这里我用了计算属性*/
    }

    .beauty-Scroll {
        .el-scrollbar {
            height: 100%; /*此处一定要设置高度，不然内层的计算属性不生效*/
        }
        .el-scrollbar__wrap {
            width: calc(~'100% + 17px'); /*将垂直滚动条挤到可视区域之外*/
            height: calc(~'100% + 17px'); /*将水平滚动条挤到可视区域之外*/
        }
    }

    input {
        width: 100%;
        height: 35px;
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        padding-left: 2px;
        padding-right: 2px;
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
        }
    }

    .alignment-left {
        text-align: left;
    }

    .alignment-right {
        text-align: right;
    }

    .el-pagination {
        white-space: inherit;
    }
</style>
